import { Col, Menu as MenuAntd, Modal as ModalAntd, Row } from "antd";
import { FaEllipsisV } from "react-icons/fa";
import { FiArrowLeftCircle, FiShare } from "react-icons/fi";
import styled, { css } from "styled-components";

interface ITheme {
  tenantTheme?: any;
  modalShare?: boolean;
}

interface IBadgePrivateCollection {
  priv?: boolean;
}

export const IconFaEllipsisV = styled(FaEllipsisV)`
  font-size: 25px;
  cursor: pointer;
`;

export const IconIoMdShare = styled(FiShare)`
  font-size: 25px;
  cursor: pointer;
`;

export const BadgePrivateCollection = styled.span<IBadgePrivateCollection>`
  display: flex;
  align-items: center;

  section {
    margin-left: 0.3rem;
  }

  background-color: ${({ priv }) => (priv ? "#009432" : "#00a3ff")};
  color: #fff;
  position: relative;
  float: right;
  left: 32px;
  bottom: 29px;

  @media (max-width: 500px) {
    left: 20px;
    bottom: 30px;
  }

  @media (min-width: 1600px) {
    border-bottom-right-radius: 10px;
  }

  padding: 0 10px 5px 10px;
  border-bottom-left-radius: 10px;
  cursor: pointer;
  img {
    margin-bottom: 5px;
  }
`;

export const LayoutBadge = styled.section`
  position: relative;
  float: right;
  margin-top: -1px;
  margin-left: -1px;
`;

export const EmptyDataRow = styled(Row)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80%;

  span {
    color: ${({ theme }) => theme.colors.textColor};
  }
`;

export const IconFiArrowLeftCircle = styled(FiArrowLeftCircle)`
  width: 22px;
  height: 22px;
`;

export const BackRow = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: max-content;
  padding-bottom: 10px;
  cursor: pointer;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textColor};

  transition: transform 0.4s;

  &:hover {
    transform: translateX(-5%);
  }
`;

export const ColTitleAndDescription = styled(Col)`
  width: 50vw;
  overflow: hidden;
`;

export const Menu = styled(MenuAntd)<ITheme>`
  ${({ theme }) =>
    theme.mode === "dark" &&
    css`
      background: #303030;
      li {
        color: #ffffff;
      }
    `}
`;

export const Modal = styled(ModalAntd)<ITheme>`
  .ant-btn.ant-btn-primary {
    background-color: ${({ theme }) => theme.colors.primary};
    border-color: ${({ theme }) => theme.colors.primary};

    &:hover {
      opacity: 0.8;
    }
  }

  ${({ modalShare }) =>
    modalShare &&
    css`
      .ant-modal-title {
        margin-right: 20px;
      }
    `}

  #input-link {
    background-color: ${({ theme }) => theme?.colors.modalBackgroundColor};
    border: none;
  }

  .ant-modal-content {
    background-color: ${({ theme }) => theme?.colors.inputBackgroundColor};

    p,
    span,
    small,
    textarea,
    input,
    .ant-modal-body,
    .ant-modal-close-x {
      color: ${({ theme }) => theme.colors.textColor};
    }

    button.ant-btn:hover,
    .ant-switch-checked {
      background: ${({ theme }) => theme.colors?.primary};
    }
    .ant-input-group-addon {
      background: ${({ theme }) => theme.colors?.primary};
      border: 1px solid ${({ theme }) => theme?.colors.modalBackgroundColor};
    }

    .ant-modal-header {
      background-color: ${({ theme }) => theme?.colors.inputBackgroundColor};
      border-bottom: 1px solid
        ${({ theme }) => theme?.colors.modalBackgroundColor};
      .ant-modal-title {
        color: ${({ theme }) => theme.colors.textColor};
      }
    }

    .ant-modal-footer {
      background-color: none;
      border-top: 1px solid ${({ theme }) => theme?.colors.modalBackgroundColor};

      button.ant-btn {
        span {
          color: ${({ theme }) => theme.colors.textColor};
        }
        background-color: transparent !important;
      }

      button.ant-btn-primary {
        background-color: ${({ theme }) => theme.colors?.primary} !important;
        span {
          color: ${({ theme }) => theme.colors.textColor};
        }
      }
    }

    textarea,
    input {
      background: ${({ theme }) => theme?.colors.modalBackgroundColor};
      border: 1px solid ${({ theme }) => theme?.colors.modalBackgroundColor};
    }
  }
`;

export const CollectionCentralizer = styled.div<ITheme>`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  .gx-product-item {
    background: transparent !important;
  }

  .ant-radio-button-wrapper {
    background: ${({ theme }) => theme.colors.backgroundColor};
    border-color: ${({ theme }) => theme.colors.borderColor};
    color: ${({ theme }) => theme.colors.textColor};
  }

  input {
    background: ${({ theme }) => theme.colors.inputBackgroundColor};
    border-color: ${({ theme }) => theme.colors.borderColor} !important;
    outline: none;
    box-shadow: none;
    color: ${({ theme }) => theme.colors.textColor};
  }

  ${({ theme }) =>
    theme.mode === "dark" &&
    css`
      .content {
        h1,
        p,
        svg {
          color: #ffffff;
        }
        button span svg {
          color: #1a1a1a !important;
        }
        a {
          svg,
          span {
            color: #ffffff;
          }
        }
      }

      .ant-select {
        .ant-select-selector {
          background-color: #282828 !important;
          border-color: #282828 !important;
          color: #ffffff;
        }

        .ant-select-clear {
          background: transparent;
        }
      }

      .gx-product-item {
        background: transparent !important;
        .gx-product-body,
        .gx-product-image,
        .gx-product-image div + div {
          background: transparent !important;
        }
        h4,
        span {
          color: #ffffff;
        }
      }
    `}

  .ant-row {
    margin-right: 0;
    margin-left: 0;
  }

  .content {
    max-width: 1400px;
    width: 100%;
    margin-bottom: 60px;

    h1 {
      font-size: 22px;
    }
    .searchCollection {
      padding-right: 20px;
    }
  }

  .content.collection {
    ${({ tenantTheme, theme }) =>
      (tenantTheme?.themeTopBar === "gradient" ||
        tenantTheme?.themeTopBar === "transparent") &&
      theme.mode !== "dark" &&
      css`
        margin-top: 13px;
      `}
  }

  .btnCreateCollection {
    display: flex;
    justify-content: flex-end;
    width: max-content;
  }

  .row-card {
    justify-content: center;
  }

  .section-card {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .render-collection-card {
      width: 350px !important;
    }

    @media (max-width: 600px) {
      justify-content: center;
    }
  }

  .ant-input-group-addon {
    vertical-align: top;
  }

  @media (max-width: 600px) {
    .content {
      padding: 0 20px;
    }
  }

  @media (max-width: 780px) {
    .searchCollection {
      padding: 0 20px 20px 0;
    }
    .btnCreateCollection {
      justify-content: center;
    }
    .ant-radio-group {
      width: max-content;
    }
  }

  @media (min-width: 1200px) {
    .colSwitchRadioItem {
      width: 22% !important;
    }
  }

  @media (max-width: 1550px) {
    .section-card .render-collection-card {
      width: 280px !important;
    }
  }
`;

export const ColRadio = styled(Col)<ITheme>`
  margin-bottom: 2rem;
  padding: 0;

  .ant-radio-button-wrapper-checked {
    span + span {
      &,
      span svg {
        color: ${({ theme }) => theme.colors.btnTextColor};
      }
    }
  }

  .ant-radio-button-wrapper:first-child {
    border-radius: 6px 0 0 6px;
  }

  .ant-radio-button-wrapper:last-child {
    border-radius: 0 6px 6px 0;
  }

  .ant-radio-button-wrapper-checked:not(
      .ant-radio-button-wrapper-disabled
    )::before {
    background: ${({ theme }) => theme.colors.primary};
  }

  .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
    background: ${({ theme }) => theme.colors.primary};
    border-color: ${({ theme }) => theme.colors.primary} !important;

    &:hover {
      background-color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const ColDropDownItem = styled(Col)`
  button.ant-btn {
    background: #323232;
    border: 1px solid #242424;
    color: #ffffff;
  }

  @media (min-width: 1200px) {
    width: 15%;
  }
`;

export const ColCollectionOwner = styled(Col)`
  display: flex;
  justify-content: flex-end;
  padding-right: 0;
`;

export const ButtonsSection = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;

  justify-content: flex-end;
  border-top: 1px solid #e8e8e8;

  padding: 0.8rem;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;

  ${({ theme }) =>
    theme.mode === "dark" &&
    css`
      button:not(:hover, :active, :focus) span {
        color: black;
      }
    `}
`;

export const ContentForm = styled.div`
  margin: 1.25rem 0 5rem 0;
`;

export const DescriptionShare = styled.p`
  margin: 20px 0px 8px 0px;
  display: flex;
  align-items: center;
`;
